import { createEmptyArrays } from './createEmptyArrays';
import { getColumnRange } from './getColumnRange';
import { SurfaceItem } from '../interfaces/SurfaceItem';

/**
 * Groups the given items, represented by their layout intervals, into columns.
 * @param items Items to be grouped by the column in which they start.
 * @param columnCount The count of columns in the current view.
 * @param columnLength The length of the columns in the current view.
 * @returns A two-dimensional array where the first level represents columns in the view
 * and the second level contains the items that start in the corresponging column.
 * NOTE: Each item will be included in a single columns in the resulting array.
 */
export function groupByStartColumn(
    items: SurfaceItem[],
    columnCount: number,
    columnLength: number
): SurfaceItem[][] {
    const result = createEmptyArrays<SurfaceItem>(columnCount);

    for (const item of items) {
        const { start } = getColumnRange(item, columnCount, columnLength);
        result[start].push(item);
    }

    return result;
}
